import { BreadcrumbsItem } from "@skyportal/ui-kit/dist/Navigation/Breadcrumbs/Breadcrumbs";
import i18n from "i18next";

export interface BreadcrumbsConfigItem {
  label: string;
  crumbs?: BreadcrumbsItem[];
  dustinIcon?: string;
  match: { path: string; exact?: boolean };
}

const dispatchNavigateEvent = (path: string) => {
  window.dispatchEvent(new CustomEvent("mf:navigate", { detail: path }));
};

export const getBreadcrumbsConfig = (): BreadcrumbsConfigItem[] => {
  const Start: BreadcrumbsItem = {
    label: i18n.t("breadcrumbs:Start"),
    path: "/start",
    customOnBreadcrumbClick: dispatchNavigateEvent,
  };

  const Storage: BreadcrumbsItem = {
    label: i18n.t("breadcrumbs:Storage"),
    path: "/storage/overview",
  };

  const Buckets: BreadcrumbsItem = {
    label: i18n.t("breadcrumbs:Buckets"),
    path: "/storage/buckets",
  };
  const breadcrumbsConfig: BreadcrumbsConfigItem[] = [
    {
      label: Storage.label,
      crumbs: [Start],
      match: {
        path: "/storage/overview",
        exact: true,
      },
    },
    {
      label: Buckets.label,
      crumbs: [Start, Storage],
      match: {
        path: "/storage/buckets",
        exact: true,
      },
    },
  ];

  return breadcrumbsConfig;
};
